import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { DialogTemplateModel } from '@core/models/models';

@Component({
  selector: 'caremoni-modal-template',
  templateUrl: './modal-template.component.html',
  styleUrl: './modal-template.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class ModalTemplateComponent implements OnInit {
  @Input() dialogTemplate: DialogTemplateModel = new DialogTemplateModel();
  @Output() closeModalHandler = new EventEmitter();
  isDisplay: boolean = false;
  constructor() { }

  ngOnInit(): void {
    this.isDisplay = true;
  }
  closeModal(){
    this.isDisplay = false;
    this.closeModalHandler.emit();
  }
}
